<template>
  <div id="map-zone-28896"></div>
</template>

<script>
import map from './AppMap.js'
export default {
  name: 'AppMap',
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
    setTimeout(() => {
      map.init('map-zone-28896', () => {
        this.$emit('loaded')
      })
    })
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>
<style>
#map-zone-28896 .town-name,
#map-zone-28896 .town-volumn {
  color: #c3dfff;
  margin: 0;
  padding: 0;
}
#map-zone-28896 .town-name {
  font-size: 13px;
}
#map-zone-28896 .town-volumn {
  font-size: 11px;
}

#map-zone-28896 .enterprise-name,
#map-zone-28896 .enterprise-volumn {
  color: #fff3df;
  margin: 0;
  padding: 0;
}
#map-zone-28896 .enterprise-name {
  color: #cfcfcf;
  font-size: 13px;
}
#map-zone-28896 .enterprise-volumn {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/screen28896/map-zone/AppMap.vue